import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import React from 'react';

export interface RadioElement extends HTMLElement {
  checked?: boolean;
  enabled?: boolean;
  disabled?: boolean;
  error?: boolean;
  success?: boolean;
}

const OpRadio = createWrapper<RadioElement>('op-radio');

export default OpRadio;
